/*
 * @Author: yyl
 * @Date: 2025-06-25 14:05:35
 * @LastEditTime: 2025-06-25 14:05:50
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/utils/request.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
// src/utils/request.js
import axios from 'axios'
import { Message } from 'element-ui'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // 统一前缀，可根据环境配置
  timeout: 10000, // 超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 示例：添加 token（如果你有登录功能）
    // const token = localStorage.getItem('token')
    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 约定：后台以 code 来判断是否成功
    if (res.code !== 200) {
      Message.error(res.message || '接口请求失败')
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res.data // 返回业务数据
  },
  error => {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service
